import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import mock11 from '../assets/images/lavendecore.png';
import mock12 from '../assets/images/eventbooq.png';
import mock13 from '../assets/images/fragrance.png';
import mock14 from '../assets/images/meetmeds.png';


import '../assets/styles/Project.scss';


function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="#" target="_blank" rel="noreferrer"><img src={mock11} className="zoom" alt="thumbnail" width="100%"/></a>
                <h2>Lavendecore — Project Management</h2>
                <p>Full-stack project management platform built with Laravel, Next.js, React, and PostgreSQL. Implemented RBAC, JWT authentication, notifications, and workflow automation.</p>
            </div>
            <div className="project">
                <a href="#" target="_blank" rel="noreferrer"><img src={mock12} className="zoom" alt="thumbnail" width="100%"/></a>
                <h2>Eventbooq — Event Management</h2>
                <p>Event management platform using Laravel and MySQL. Built RESTful APIs, JWT authentication, multi-tenant modules, and Swagger documentation for faster frontend integration.</p>
            </div>
            <div className="project">
                <a href="#" target="_blank" rel="noreferrer"><img src={mock13} className="zoom" alt="thumbnail" width="100%"/></a>
              <h2>Fragrance World — Admin Platform</h2>
                <p>Administration platform with OTP authentication via Twilio SMS, collection management, and role-based access control. Optimized MySQL queries to improve response times.</p>
            </div>
            <div className="project">
                <a href="#" target="_blank" rel="noreferrer"><img src={mock14} className="zoom" alt="thumbnail" width="100%"/></a>
                <h2>MeetMeds — Healthcare Referral</h2>
                <p>Backend APIs supporting doctor referral workflows, patient data management, and reporting features using Laravel and MySQL. Focused on reliability and maintainability.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;